import { FieldModel } from 'app/models/shared/field.model';
import { FieldGroupModel } from 'app/models/shared/fieldGroup.model';
import { FieldGroupComponent } from './../field-group/field-group.component';
import { Component, OnInit, Input, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { ModalController, NavParams, AlertController } from '@ionic/angular';
import { FormGroup, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { NativeService } from 'app/services/native.service';
import { FormService } from 'app/services/form.service';

@Component({
    selector: 'app-modal-details-edit',
    templateUrl: './modal-details-edit.component.html',
    styleUrls: ['./modal-details-edit.component.scss'],
    standalone: false
})
export class ModalDetailsEditComponent implements OnInit, AfterViewInit
{

	@Input() title: string;
	@Input() subtitle: string;
	@Input() field_groups: FieldGroupModel[];
	@Input() isDirty: boolean = false;
	@Input() classes: string = '';
	@Input() saveIcon: string = 'checkmark-sharp';
	@Input() data: any;
	@Input() buttons: [];

	saveActivated: boolean = false;
	public hasErrors = false;

	constructor(
		public modalController: ModalController,
		public navParams: NavParams,
		public alertController: AlertController,
		public nativeService: NativeService,
		protected cd: ChangeDetectorRef,
		private formService: FormService,
	)
	{
	}

	ngOnInit()
	{
		// console.log('ngOnInit modal-details-edit.component.ts');
	}

	ngAfterViewInit(): void
	{
	}

	protected ionViewWillLeave()
	{
		// this.nativeService.setupStatusBar(this.statusBarColor);
	}

	async saveModal()
	{
		this.saveActivated = true;
		var errorFields = this.errorFields();
		if (errorFields.length > 0)
		{
			var message = "There is an error on the form that needs correcting before you can save.";
			if (errorFields.length > 1)
			{
				message = "There are " + errorFields.length + " errors that need correcting before you can save.";
			}

			const alert = await this.alertController.create({
				header: "Form Data Error",
				message: message,
				buttons: [
					{
						text: 'OK',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
						}
					}
				]
			});
			await alert.present();
		}
		else if (this.isDirty)
		{
			this.syncFormWithObject();
			this.dismissTheModal(true);
		}
		else
		{
			this.dismissTheModal(false); //no need to save
		}
	}

    public syncFormWithObject(): boolean
    {
        if (this.isDirty && this.field_groups && this.data) {
            return FormService.syncFormWithObject(this.field_groups, this.data);
        }
		return false;
    }

	async cancelModal()
	{
		// console.log('cancelModal', this.isDirty);
		if (this.isDirty)
		{
			//prompt user to save
			const alert = await this.alertController.create({
				header: "Unsaved changes",
				message: "Some data has changed. Do you want to close without saving?",
				buttons: [
					{
						text: 'Cancel',
						role: 'cancel',
						cssClass: 'primary',
						handler: () =>
						{
							//do nothing
							return;
						}
					},
					{
						text: 'OK',
						cssClass: 'danger',
						handler: () =>
						{
							this.dismissTheModal(false);
						}
					}
				]
			});

			await alert.present();
		}
		else
		{
			this.dismissTheModal(false);
		}
	}

	private dismissTheModal(save: boolean)
	{
		// console.log('dismissTheModal', save);
		// Dismiss the top modal returning some data object
		this.modalController.dismiss({
			'result': {
				save: save
			}
		});
	}

	submitted = false;

	onSubmit() { this.submitted = true; }

	public async handleFieldClicked(ev: any)
	{
		switch (ev.detail.type)
		{
			case "wholesale-contact":
				// Dismiss the top modal returning some data object
				this.modalController.dismiss({
					'fieldClicked': ev.detail
				});
				break;
		}
	}

	public handleFieldRefreshed(ev: any)
	{
		// console.log('handleFieldRefreshed', ev);
		if (ev.detail && ev.detail.refresh)
		{
			// console.log(this.field_groups);
			setTimeout(() =>
			{
				this.cd.detectChanges();
			}, 500);
		}
	}

	public handleFieldChanged(ev: any)
	{
		// console.log('handleFieldChanged', ev);
		if (ev.detail && ev.detail.refresh)
		{
			// console.log(this.field_groups);
			setTimeout(() =>
			{
				this.cd.detectChanges();
			}, 500);
		}
		else
		{
			this.isDirty = true;

			//see if this field has children
			var changedField: FieldModel = ev.detail.field;
			if (changedField.hasChildren)
			{
				switch (changedField.type)
				{
					case "select":
						this.formService.checkLookupChildren(this.field_groups, changedField);
						break;
				}
			}

			//see if we need to toggle a group
			var redraw_form = false;
			for (let field_group_toggle of this.field_groups)
			{
				if (field_group_toggle.toggleVisibilityOn)
				{
					var toggleVisibilityOn = field_group_toggle.toggleVisibilityOn;
					var fieldValue = "";
					//loop through each group looking for the value in the form
					for (let field_group_loop of this.field_groups)
					{
						for (let field of field_group_loop.fields)
						{
							if (field.id == toggleVisibilityOn)
							{
								//console.log("Found field "+toggleVisibilityOn);
								fieldValue = field.value.toString();
							}
						}
					}
					//console.log("field_group_toggle.hidden = ("+fieldValue+" != "+field_group_toggle.toggleVisibleWhen);
					field_group_toggle.hidden = (fieldValue != field_group_toggle.toggleVisibleWhen);
				}
			}


			this.handleFieldChangedAdditional(ev);
		}

	}


	public errorFields(): FieldModel[]
	{
		var errors: FieldModel[] = [];
		for (let field_group of this.field_groups)
		{
			for (let field of field_group.fields)
			{
				if (field.invalid) errors.push(field);
			}
		}
		return errors;
	}

	scrollTop: boolean = true;
	ionScrollEvent(ev: any)
	{
		var scrollTop = (ev.detail.scrollTop == 0);
		if (this.scrollTop != scrollTop)
		{
			this.scrollTop = scrollTop;
		}
	}

	handleFieldChangedAdditional(ev: any)
	{
	}

    public dismissModal(button: any)
	{
		if (button.disabled) return;
		// Dismiss the top modal returning some data object
		this.modalController.dismiss({
			'result': button.name
		});
	}

}
